import { useMemo } from 'react';

import { useQuery } from '@mint-lib/query-client';
import { Auth } from '@mint-sdk/api-auth';

type Params = {
  enabled: boolean;
  searchValue: string;
};

const useWorkspaceUsers = ({ enabled, searchValue }: Params) => {
  const { data = [], isLoading } = useQuery({
    ...Auth.listUsersShort({
      params: {},
    }),
    enabled,
  });

  const users = useMemo(() => {
    const activeUsers = data.filter((user) => user.isActive && !user.isDeleted);

    if (!searchValue) return activeUsers;

    const search = searchValue.toLowerCase();

    return activeUsers.filter(
      (user) =>
        `${user.firstName} ${user.lastName}`.toLowerCase().includes(search) ||
        user.email.toLowerCase().includes(search),
    );
  }, [data, searchValue]);

  return { users, isLoading };
};

export { useWorkspaceUsers };
